import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { deleteBoardsUserRoles } from '../requests';
import type { DeleteBoardsUserRolesRequestType } from '../types';

export type UseDeleteBoardsUserRolesMutationParams = Omit<
  DeleteBoardsUserRolesRequestType,
  'boardId'
> & {
  boardId?: number;
};

export const useDeleteBoardsUserRoles = (specBoardId?: number) => {
  const queryClient = useQueryClient();
  const currentBoardId = useGetCurrentBoardId();
  const boardId = (specBoardId || currentBoardId) as number;

  return useMutation({
    mutationFn: (data: UseDeleteBoardsUserRolesMutationParams) =>
      deleteBoardsUserRoles({
        ...data,
        boardId,
      }),
    onSuccess: (_, variables) =>
      Promise.all(
        variables.documentIds.map(documentId =>
          queryClient.invalidateQueries({
            queryKey: [API_QUERY_KEYS.documentsUserRoles, { documentId }],
          }),
        ),
      ),
  });
};
